module.exports = __webpack_public_path__ + "img/73.e56af673.jpg";